import { IoChevronBack, IoChevronDown, IoChevronUp, IoClose } from "react-icons/io5";
import { useState, useEffect, useMemo, useRef, useCallback } from "react";
import { useNavigate, useParams, Link, useSearchParams } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useModal } from 'react-hooks-use-modal';
import { useAtom } from 'jotai';
import { activeOrdersAtom } from '../../auth';
import { Tabbar } from "../../compornents/Tabbar";
import { BirthdayBanner } from "../../compornents/BirthdayBanner";
import { Pagination } from 'swiper/modules';
import { Post } from '../../compornents/Post';
import { TailSpin } from 'react-loading-icons'
import { toast } from 'react-toastify';
import { Analytics,Gtag } from '../../compornents/Analytics';
import { bagFirstStage, BAG_FIRST_TEXT } from '../../bagFirst';
import BagFirstNext from '../../compornents/BagFirstNext';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import { Map, Marker as GMarker } from '@vis.gl/react-google-maps';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import 'swiper/css';
import 'swiper/css/pagination';
import { orderSelfAtStore } from '../../selfDropoff';

// 地図の中心位置とズームレベルを更新するためのカスタムフック
const UpdateMapView = ({ position, destination }) => {
  const map = useMap();
  const bounds = useMemo(() => L.latLngBounds([position, destination]), [position, destination]);

  useEffect(() => {
    map.fitBounds(bounds);
  }, [bounds, map]);

  return null;
};

function OrderDetail() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [activeOrders, setActiveOrders] = useAtom(activeOrdersAtom);
  const [activeOrder, setActiveOrder] = useState(null);
  const [isRequesting, setIsRequesting] = useState(false); // bag-first CTA の二重送信防止

  // カスタムアイコンを定義する
  const carIcon = L.icon({
    iconUrl: '/img/car-solid.svg',
    iconSize: [25, 41],
    iconAnchor: [12, 21],
    popupAnchor: [1, -24],
  });

  const destinationIcon = L.icon({
    iconUrl: '/img/house-solid.svg',
    iconSize: [25, 41],
    iconAnchor: [12, 21],
    popupAnchor: [1, -24],
  });

  const options = {
    disableDefaultUI: true,
    zoomControl: false,
    clickableIcons: false
  };

  // 初期化
  const [position, setPosition] = useState(null);
  const [destination, setDropoffLocation] = useState(null);
  const [smsText, setSmsText] = useState(null);
  const [defaultSlide, setDefaultSlide] = useState(0);

  // モーダル
  const [Modal, , closeModal] = useModal('root', {});
  const [LoadingModal, openLoadingModal, closeLoadingModal] = useModal('root', {});
  const [DeliveryBagModal, openDeliveryBagModal, closeDeliveryBagModal] = useModal('root', {});
  const [DeliveryCustomerPickupModal, openDeliveryCustomerPickupModal, closeDeliveryCustomerPickupModal] = useModal('root', {});
  const [DeliveryModal, openDeliveryModal, closeDeliveryModal] = useModal('root', {});
  const [DropoffModal, openDropoffModal, closeDropoffModal] = useModal('root', {});
  const [LockerPickupModal, openLockerPickupModal, closeLockerPickupModal] = useModal('root', {});
  const [SpotPickupModal, openSpotPickupModal, closeSpotPickupModal] = useModal('root', {});
  const swiperRef = useRef(null);

  // FAQの開閉状態管理
  const [openFaqIndex, setOpenFaqIndex] = useState(null);

  const fetchLocation = useCallback(async (order_id) => {
    // console.log('fetchLocation');
    try {
      const request_data = { order_id: order_id }
      const response = await Post('post', '/order/location.php', request_data);
      if (response.order_id_invalid === 0) {
        setActiveOrder(response.order);
        console.log(response.order);
        // activeOrdersも更新
        setActiveOrders(prev => prev.map(o => o.id === order_id ? response.order : o));

        if (response.delivery_not_found===0){
          if (response.webhook_not_found === 0) {
            setPosition([response.location_lat, response.location_lng]);
            setDropoffLocation([response.dropoff_location_lat, response.dropoff_location_lng]);
            setSmsText(response.sms_txt);
          }else{
            setPosition(null);
          }
        } else {
          setPosition(null);
        }

        if (Number(response.order.otype)!==1 && Number(response.order.otype)!==2 && Number(response.order.otype)!==7){
          // console.log('A');
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }

        if(response.order.user_dropoff_type!=='uber'){
          // console.log('B');
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }

        // キャンセルされた
        if(response.order.delivery_type === null && (response.order.item_type === 'bag' || response.order.item_type==='futon_bag')){
          // console.log('C');
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }

        if (response.order.item_type === 'bag' && Number(response.order.otype) === 8){
          // console.log('D');
          clearInterval(intervalRef.current);
          intervalRef.current = null;
          navigate("/order_step/step0");
        }
      } else {
        // console.log('E');
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        // navigate("/home");
      }
    } catch (error) {
      console.error('位置情報の取得に失敗しました', error);
    }
  }, [setActiveOrders, navigate]);

  const intervalRef = useRef(null);
  const fetchLocationRef = useRef(null);

  // fetchLocationの参照を更新
  fetchLocationRef.current = fetchLocation;

  // 戻る
  const back = () => {
    navigate("/home");
  };

  // 注文をAPIから取得する関数
  const fetchActiveOrder = useCallback(async (orderId) => {
    try {
      const request_data = {};
      const response_data = await Post('post', '/order/active.php', request_data);
      if (response_data.result === 1) {
        const activeOrders = Array.isArray(response_data.active_orders)
          ? response_data.active_orders
          : (response_data.active_orders ? [response_data.active_orders] : []);

        const targetOrder = activeOrders.find(o => o.id === orderId);
        if (targetOrder) {
          setActiveOrder(targetOrder);

          // activeOrdersも更新
          setActiveOrders(activeOrders);

          // otypeに応じて初期スライドを設定
          if(Number(targetOrder.otype) >= 3 && Number(targetOrder.otype) <= 5){
            setDefaultSlide(2);
          }
          if(Number(targetOrder.otype) === 6 || Number(targetOrder.otype) === 7){
            setDefaultSlide(4);
          }
          return true;
        }
      }
      return false;
    } catch (error) {
      console.error('Error fetching active order:', error);
      return false;
    }
  }, [setActiveOrders]);

  // URLパラメータの存在を安定した値として保持
  const hasUrlParam = useMemo(() => searchParams.get('p'), [searchParams]);

  useEffect(() => {
    // URLパラメータ 'p' がある場合は常にAPIから取得
    if (hasUrlParam) {
      // URLパラメータがある場合は常にAPIから最新の注文情報を取得
      fetchActiveOrder(id).then(success => {
        if (!success) {
          // APIからも取得できない場合はホームに戻る
          navigate("/home");
        }
      });
    } else {
      // 通常の処理：指定されたIDの注文を探す
      const order = activeOrders.find(o => o.id === id);
      if (order) {
        setActiveOrder(order);

        // otypeに応じて初期スライドを設定
        if(Number(order.otype) >= 3 && Number(order.otype) <= 5){
          setDefaultSlide(2);
        }
        if(Number(order.otype) === 6 || Number(order.otype) === 7){
          setDefaultSlide(4);
        }
      } else {
        // activeOrdersに見つからない場合はAPIから取得を試行
        fetchActiveOrder(id).then(success => {
          if (!success) {
            // APIからも取得できない場合はホームに戻る
            // console.log('注文が見つからない場合はホームに戻る');
            navigate("/home");
          }
        });
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, navigate, fetchActiveOrder, hasUrlParam]);

  // 位置情報追跡の必要性を計算
  const needsLocationTracking = useMemo(() => {
    if (!activeOrder) return false;
    return ((Number(activeOrder.otype) === 1 || Number(activeOrder.otype) === 2) &&
      (activeOrder.delivery_type !== null || activeOrder.user_dropoff_type==='uber')) ||
      Number(activeOrder.otype) === 7;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeOrder?.otype, activeOrder?.delivery_type, activeOrder?.user_dropoff_type]);

  // 位置情報の取得用のuseEffect（別管理）
  useEffect(() => {
    if (!activeOrder || !needsLocationTracking) {
      // 不要な場合はintervalをクリア
      if(intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      return;
    }

    // 即座に一度実行
    fetchLocationRef.current(activeOrder.id);

    // 既存のintervalをクリア
    if(intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    // 新しいintervalを設定
    intervalRef.current = setInterval(() => {
      fetchLocationRef.current(activeOrder.id);
    }, 20000);

    return () => {
      if(intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeOrder?.id, needsLocationTracking]);

  // トラッキングURL
  const openTrackingUrl = () => {
    Gtag('open_tracking_url');
    window.open(activeOrder.tracking_url, '_blank');
  };

  // 配達を依頼する
  async function requestDeliveryBag() {
    Gtag('request_redelivery_bag', {
      order_id: activeOrder.id,
    });
    openLoadingModal();
    const request_data = { order_id: activeOrder.id, type:'delivery_bag'};
    const response_data = await Post('post', '/order/request_delivery.php', request_data);
    if (response_data.result === 1) {
      setActiveOrder(response_data.order);
      setActiveOrders(prev => prev.map(o => o.id === activeOrder.id ? response_data.order : o));
      if(intervalRef.current === null){
        intervalRef.current = setInterval(() => {
          fetchLocation(activeOrder.id);
        }, 20000);
      }
    } else {
      toast.error(response_data.error_message);
    }
    closeDeliveryBagModal();
    closeLoadingModal();
  }

  // Cpickupの配達を依頼する
  async function requestDeliveryCustomerPickup() {
    Gtag('request_redelivery_bag', {
      order_id: activeOrder.id,
    });
    openLoadingModal();
    const request_data = { order_id: activeOrder.id, type:'customer_pickup'};
    const response_data = await Post('post', '/order/request_delivery.php', request_data);
    if (response_data.result === 1) {
      setActiveOrder(response_data.order);
      setActiveOrders(prev => prev.map(o => o.id === activeOrder.id ? response_data.order : o));
      if(intervalRef.current === null){
        intervalRef.current = setInterval(() => {
          fetchLocation(activeOrder.id);
        }, 20000);
      }
    } else {
      toast.error(response_data.error_message);
    }
    closeDeliveryCustomerPickupModal();
    closeLoadingModal();
  }

  // お預け完了
  async function successDropoff() {
    Gtag('success_dropoff', {
      order_id: activeOrder.id,
    });
    openLoadingModal();
    const request_data = {order_id:activeOrder.id,type:'dropoff'};
    const response_data = await Post('post', '/order/open_success_box_web.php', request_data);
    closeLoadingModal();
    closeDropoffModal();
    if (response_data.result === 1) {
      setActiveOrder(response_data.order);
      setActiveOrders(prev => prev.map(o => o.id === activeOrder.id ? response_data.order : o));
      if(intervalRef.current === null){
        intervalRef.current = setInterval(() => {
          fetchLocation(activeOrder.id);
        }, 20000);
      }
      if (swiperRef.current && swiperRef.current.slideTo) {
        swiperRef.current.slideTo(2, 0);
      }
    } else {
      toast.error(response_data.error_message);
    }
  }

  // 今すぐUberで受け取る
  async function requestDelivery() {
    Gtag('request_delivery', {
      order_id: activeOrder.id,
    });
    openLoadingModal();
    const request_data = {order_id:activeOrder.id,type:'lpspot_pickup'};
    const response_data = await Post('post', '/order/request_delivery.php', request_data);
    closeLoadingModal();
    closeDeliveryModal();
    if (response_data.result === 1) {
      setActiveOrder(response_data.order);
      setActiveOrders(prev => prev.map(o => o.id === activeOrder.id ? response_data.order : o));
      if(intervalRef.current === null){
        intervalRef.current = setInterval(() => {
          fetchLocation(activeOrder.id);
        }, 20000);
      }
    } else {
      toast.error(response_data.error_message);
    }
  }

  // 自分でロッカーから受け取る
  async function successPickup() {
    Gtag('success_pickup', {
      order_id: activeOrder.id,
    });
    openLoadingModal();
    const request_data = {order_id:activeOrder.id,type:'pickup'};
    const response_data = await Post('post', '/order/open_success_box_web.php', request_data);
    closeLoadingModal();
    closeLockerPickupModal();
    if (response_data.result === 1) {
      // 完了した注文を削除
      setActiveOrders(prev => prev.filter(o => o.id !== activeOrder.id));
      navigate("/home");
    } else {
      toast.error(response_data.error_message);
    }
  }

  const formatDeadline = (dateStr) => {
    const date = new Date(dateStr.replace(/-/g, '/'));
    const weekdays = ['日', '月', '火', '水', '木', '金', '土'];
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const weekday = weekdays[date.getDay()];
    const hour = date.getHours();
    const minute = date.getMinutes();
    return `${month}/${day}(${weekday}) ${hour}時${minute}分`;
  };

  // 店舗お預け期限の日付を計算する関数
  const calculateDropoffDeadline = (orderDay, limitDays) => {
    if (!orderDay || !limitDays) return null;
    const orderDate = new Date(orderDay.replace(/-/g, '/'));
    const limitDate = new Date(orderDate);
    limitDate.setDate(limitDate.getDate() + Number(limitDays));
    const month = limitDate.getMonth() + 1;
    const day = limitDate.getDate();
    return `${month}月${day}日`;
  };

  const lockerRef = useRef(null);
  const scrollToLocker = () => {
    lockerRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  // bag-first（2026-09-01）: otype=1 のまま bag_status で「バッグお届け中／到着済み」を表す区間。
  // 従来の表示は deliveries の型(-1/0)で分岐するため、この区間だと「集荷のUber配達員を募集中です」等の
  // 誤った案内が出ていた。ホームと同じ判定(bagFirstStage)・同じCTA(BagFirstNext)をここにも出す（2026-09-03）。
  const bagStage = bagFirstStage(activeOrder);
  const bagText = bagStage ? BAG_FIRST_TEXT[bagStage] : null;

  // 集荷を依頼する（bag_status='arrived' のときだけ押せる。Home.jsx requestPickup と同じ遷移）
  const requestPickupBagFirst = async () => {
    if (!activeOrder || isRequesting) return;
    setIsRequesting(true);
    openLoadingModal();
    try {
      const res = await Post('post', '/order/request_delivery.php', { order_id: activeOrder.id, type: 'customer_pickup' });
      if (res?.result === 1) {
        Gtag('bag_first_request_pickup', { order_id: activeOrder.id, from: 'order_detail' });
        setActiveOrder(res.order);
        setActiveOrders(prev => prev.map(o => o.id === activeOrder.id ? res.order : o));
        if (intervalRef.current === null) {
          intervalRef.current = setInterval(() => { fetchLocation(activeOrder.id); }, 20000);
        }
      } else {
        toast.error(res?.error_message || '集荷のご依頼に失敗しました。時間をおいて再度お試しください');
      }
    } catch (e) {
      toast.error('集荷のご依頼に失敗しました。時間をおいて再度お試しください');
    } finally {
      closeLoadingModal();
      setIsRequesting(false);
    }
  };

  // 専用バッグのお届けを再依頼する（配達失敗時のみ表示。Home.jsx requestBagAgain と同じ）
  const requestBagAgainBagFirst = async () => {
    if (!activeOrder || isRequesting) return;
    setIsRequesting(true);
    openLoadingModal();
    try {
      const res = await Post('post', '/order/request_delivery.php', { order_id: activeOrder.id, type: 'delivery_bag' });
      if (res?.result === 1) {
        toast.success('専用バッグのお届けを再度手配しました');
        setActiveOrder(res.order);
        setActiveOrders(prev => prev.map(o => o.id === activeOrder.id ? res.order : o));
      } else {
        toast.error(res?.error_message || 'お届けの再依頼に失敗しました。時間をおいて再度お試しください');
      }
    } catch (e) {
      toast.error('お届けの再依頼に失敗しました。時間をおいて再度お試しください');
    } finally {
      closeLoadingModal();
      setIsRequesting(false);
    }
  };

  if (!activeOrder) {
    return <div></div>;
  }

  return (
    <div className="App">
      <div className="Home">
        <Analytics title="進行中の注文" />
        <div className="toolbar">
          <div className="toolbar_left div_btn" onClick={back}>
            <IoChevronBack />
          </div>
          <div className="toolbar_center">
            進行中の注文
          </div>
          <div className="toolbar_right">
          </div>
        </div>
        <div className="mb-5">
          <BirthdayBanner style={{ margin: '12px 16px 0' }} />

          <div>
            {Number(activeOrder.otype) === 1 ? (
              <div>
                {bagStage !== '' ? (
                  <div className="mb-3">
                    <div className="mb-3 home_header">
                      <div className="h5">{bagText.title}</div>
                      <div className="text-left">{bagText.lead}</div>
                      {bagStage === 'delivering' && activeOrder.pincode && (
                        <>
                          <div className="text-left mt-2">暗証番号をUber配達員にお伝えください</div>
                          <div className="h5">暗証番号 <strong>{activeOrder.pincode}</strong></div>
                        </>
                      )}
                    </div>
                    <div className="mr-3 ml-3">
                      <BagFirstNext
                        order={activeOrder}
                        onRequestPickup={requestPickupBagFirst}
                        onRequestBagAgain={requestBagAgainBagFirst}
                        isRequesting={isRequesting}
                      />
                      {bagStage === 'delivering' && activeOrder.tracking_url && (
                        <div className="mb-3">
                          <button className="btn btn-oval btn-outline-secondary form-control" onClick={openTrackingUrl}>配送状況の確認</button>
                        </div>
                      )}
                    </div>
                  </div>
                ) : activeOrder.user_dropoff_type==='uber' ? (
                  <>
                    {Number(activeOrder.delivery_type) === -1 ? (
                      <div className="mb-3">
                        <div className="mb-3 home_header">
                          <div>
                            <div className="text-left">
                              {activeOrder.type==='futon_bag' && 'ふとん'}
                              専用バッグをご自宅にお届けします
                            </div>
                            <div className="text-left">暗証番号をUber配達員にお伝えください</div>
                            <div className="h5">暗証番号 <strong>{activeOrder.pincode}</strong></div>
                          </div>
                        </div>
                      </div>
                    ) : activeOrder.delivery_type === null ? (
                      <div className="mb-3">
                        <div className="mb-3 home_header">
                          <div className="text-left">配達がキャンセルされました</div>
                          <div className="h5">再度、配達を依頼してください</div>
                        </div>
                      </div>
                    ) : Number(activeOrder.delivery_type) === 0 && (
                      <div className="mb-3">
                        <div className="mb-3 home_header">
                          {activeOrder.delivery_status === 'pending' || activeOrder.delivery_status === undefined ? (
                            <div>
                              <div className="text-left">ご注文ありがとうございます！</div>
                              <div className="h5">集荷のUber配達員を募集中です</div>
                            </div>
                          ) : activeOrder.delivery_status === 'pickup' && (
                            <>
                              <div className="h5">Uber配達員が集荷に向かっています.{smsText}</div>
                            </>
                          )}
                        </div>
                        {position !== null && (
                          <MapContainer center={[(position[0] + destination[0]) / 2, (position[1] + destination[1]) / 2]} zoom={13} style={{ height: "50vh", width: "100%" }}>
                            <TileLayer
                              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                            />
                            <Marker position={position} icon={carIcon}>
                              <Popup>
                                移動する車
                              </Popup>
                            </Marker>
                            <Marker position={destination} icon={destinationIcon}>
                              <Popup>
                                目的地
                              </Popup>
                            </Marker>

                            <UpdateMapView position={position} destination={destination} />
                          </MapContainer>
                        )}
                      </div>

                    )}
                  </>
                ): activeOrder.user_dropoff_type==='own' && (
                  <>
                    <div className="mb-3">
                      <div className="mb-3 home_header">
                        <div className="h5">専用バッグにご依頼品を入れて</div>
                        <div className="h5">
                          {orderSelfAtStore(activeOrder) ? (
                            <>
                              ご注文から<span className="text-danger">{activeOrder?.lpspot?.spot_dropoff_limit_days}日以内
                              {calculateDropoffDeadline(activeOrder.order_day, activeOrder?.lpspot?.spot_dropoff_limit_days) && (
                                <>({calculateDropoffDeadline(activeOrder.order_day, activeOrder?.lpspot?.spot_dropoff_limit_days)}まで)</>
                              )}</span>
                              に店舗にお持ちください
                            </>
                          ):(
                            <>
                              {formatDeadline(activeOrder.spot_dropoff_expire_day)}までに
                              ロッカーに預けてください
                            </>
                          ) }
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            ) : Number(activeOrder.otype) === 2 ? (
              <div>
                <div className="mr-4 ml-4 mt-4 mb-2">
                  <div className="h5">Uber配達員が配送中です</div>
                </div>
              </div>
            ) : Number(activeOrder.otype) >= 3 && Number(activeOrder.otype) <= 5 ? (
              <div>
                <div className="mr-4 ml-4 mt-4 mb-2">
                  <div className="h5">クリーニング完了まで<br/>しばらくお待ちください</div>
                </div>
              </div>
            ) : Number(activeOrder.otype) === 6 ? (
              <div>
                <div className="mr-4 ml-4 mt-4 mb-2">
                  <div className="h5">クリーニングが完了しました</div>
                  <div className="">お受け取りをお願いします</div>
                </div>
              </div>
            ) : Number(activeOrder.otype) === 7 && (
              <div>
                <div className="mb-3 home_header">
                  <div className="">暗証番号をUber配達員にお伝えください</div>
                  <div className="h5">暗証番号 <strong>{activeOrder.pincode}</strong></div>
                </div>
              </div>
            )}
            {activeOrder.item_type === 'bag' || activeOrder.item_type === 'futon_bag' ? (
              <div>
                {/* 初回ステップ */}
                <div className="">
                  <div className="">
                    <Swiper
                      onSwiper={(swiper) => (swiperRef.current = swiper)}
                      slidesPerView={'auto'}
                      spaceBetween={10}
                      pagination={{
                        clickable: true,
                      }}
                      modules={[Pagination]}
                      className="mySwiper">
                      <SwiperSlide key="bag-step1">
                        <div className="swiper_div2 rounded-lg">
                          <div className="">
                            <img src="/img/step01-01.png" alt="step1" className="ItemImage" />
                          </div>
                          <div className="p-3">
                            <div className="h4 mb-3 text-center">
                              {activeOrder.type==='futon_bag' && 'ふとん'}専用バッグを受け取る
                            </div>
                            <div className="mb-3">
                              Uber配達員がご自宅に{activeOrder.type==='futon_bag' && 'ふとん'}専用バッグをお届けします。<br />
                              暗証番号をUber配達員に伝えてください。
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    </Swiper>
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <div className="">
                  <Swiper
                    onSwiper={(swiper) => {
                      swiperRef.current = swiper;
                      swiper.slideTo(defaultSlide, 0);
                    }}
                    slidesPerView={'auto'}
                    spaceBetween={10}
                    pagination={{
                      clickable: true,
                    }}
                    modules={[Pagination]}
                    className="mySwiper">
                    <SwiperSlide key="step1">
                      <div className={Number(activeOrder.otype) <= 2 ? "swiper_div rounded-lg" : "swiper_div rounded-lg swiper_success"}>
                        <div className="">
                          {activeOrder.item_type==='futon' ? (
                            <img src="/img/step1-futon.png" alt="step1" className="ItemImage" />
                          ):(
                            <img src="/img/step2-01.png" alt="step1" className="ItemImage" />
                          )}
                        </div>
                        <div className="p-3">
                          <div className="h5 mb-3 text-center">
                            {activeOrder.item_type==='futon' ? (
                              <>
                                注文した点数のふとんを<br />
                                ふとん専用バッグに入れる
                              </>
                            ):(
                              <>
                                注文した点数の衣類を<br />
                                専用バッグに入れる
                              </>
                              )}
                          </div>
                          <div className="text-danger">
                            <small>
                              ※専用バッグに入る分のみ受付可能です<br />
                              ※専用バッグに入れてしっかりと密封してください<br />
                              ※ご依頼品がしっかり密封されてない場合、サービスをお受けできない場合があります
                            </small>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                    {activeOrder.user_dropoff_type==='uber' ? (
                      <SwiperSlide key="step2-uber">
                      <div className={Number(activeOrder.otype) <= 2 ? "swiper_div rounded-lg" : "swiper_div rounded-lg swiper_success"}>
                        <div className="">
                          <img src="/img/step2-02.png" alt="step2" className="ItemImage" />
                        </div>
                        <div className="p-3">
                          <div className="h4 mb-3 text-center">
                            Uber配達員に渡す
                          </div>
                          <div className="mb-3">
                            Uber配達員が専用バッグを集荷するためにご自宅に伺います。<br />
                            到着後、<span className="text-danger">しっかりと密閉した</span>袋をお渡しください。
                          </div>
                        </div>
                      </div>
                      </SwiperSlide>
                    ):activeOrder.user_dropoff_type==='own' && (
                      <>
                      {orderSelfAtStore(activeOrder) ? (
                        <SwiperSlide key="step2-spot">
                          <div className={Number(activeOrder.otype) <= 2 ? "swiper_div rounded-lg" : "swiper_div rounded-lg swiper_success"}>
                            <div className="">
                              <img src="/img/step2-futon.png" alt="step2" className="ItemImage" />
                            </div>
                            <div className="p-3">
                              <div className="h4 mb-3 text-center">
                                店舗にお持ちください
                              </div>
                              <div className="mb-3">
                                期限までにご依頼品を指定の店舗までお持ちください。<br/>
                                {Number(activeOrder.otype)===1 && (
                                  <Link onClick={scrollToLocker}>店舗の場所はこちら</Link>
                                )}
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      ):(
                        <SwiperSlide key="step2-locker">
                          <div className={Number(activeOrder.otype) <= 2 ? "swiper_div rounded-lg" : "swiper_div rounded-lg swiper_success"}>
                            <div className="">
                              <img src="/img/Group 1390.png" alt="step2" className="ItemImage" />
                            </div>
                            <div className="p-3">
                              <div className="h4 mb-3 text-center">
                                ロッカーに預けてください
                              </div>
                              <div className="mb-3">
                                期限までに専用バッグを預けてください。<br/>
                                {Number(activeOrder.otype)===1 && (
                                  <Link onClick={scrollToLocker}>ロッカーの場所や操作方法はこちら</Link>
                                )}
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      )}
                      </>
                    )}
                    <SwiperSlide key="step3-cleaning">
                      <div  className={Number(activeOrder.otype) <= 5 ? "swiper_div rounded-lg" : "swiper_div rounded-lg swiper_success"}>
                        <div className="">
                          <img src="/img/step2-032.png" alt="ste3" className="ItemImage" />
                        </div>
                        <div className="p-3">
                          <div className="h4 mb-3 text-center">
                            クリーニング
                          </div>
                          <div className="mb-3">
                            クリーニングが仕上がるまで、しばらくお待ちください
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide key="step4-complete">
                      <div  className={Number(activeOrder.otype) <= 5 ? "swiper_div rounded-lg" : "swiper_div rounded-lg swiper_success"}>
                        <div className="">
                          <img src="/img/step2-03.png" alt="ste3" className="ItemImage" />
                        </div>
                        <div className="p-3">
                          <div className="h4 mb-3 text-center">
                            クリーニング完了
                          </div>
                          <div className="mb-3">
                            クリーニングが完了したら、SMSメールまたは注文履歴のページにてお知らせします。
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide key="step5-pickup">
                      <div className="swiper_div rounded-lg">
                        <div className="">
                          <img src="/img/step2-04.png" alt="step4" className="ItemImage" />
                        </div>
                        <div className="p-3">
                          <div className="h4 mb-3 text-center">
                            お受け取り
                          </div>
                          <div className="mb-3">
                            {Number(activeOrder?.lpspot?.can_user_dropoff_locker) === 1 ? (
                              <>
                                ２つの方法からお選びいただけます<br/>
                                ・自宅にUberが届ける<br/>
                                ・{orderSelfAtStore(activeOrder) ? '店舗で' : 'ロッカーから'}受け取る<br/>
                                <div className="text-danger">※{orderSelfAtStore(activeOrder) ? '店舗で' : 'ロッカーから'}受け取ると300円クーポンプレゼント!</div>
                                {Number(activeOrder.otype)===6 && (
                                  <Link onClick={scrollToLocker}>{orderSelfAtStore(activeOrder) ? '店舗' : 'ロッカー'}についてはこちら</Link>
                                )}
                              </>
                            ) : (
                              <>
                                自宅にUberがお届けします
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </div>
                {Number(activeOrder?.lpspot?.can_user_dropoff_locker) === 1 && !orderSelfAtStore(activeOrder) && (
                  <>
                    {((activeOrder.user_dropoff_type==='own' && Number(activeOrder.otype)===1) ||  Number(activeOrder.otype)===6) && (
                      <>
                        <h4 ref={lockerRef} className="ml-1 mb-1">ロッカーについて</h4>
                        {Number(activeOrder.otype)===1 ? (
                          <>
                            <div className="title">
                              ロッカーお預け期限
                            </div>
                            <div className="content">
                              <div className="h5 text-danger">{formatDeadline(activeOrder.spot_dropoff_expire_day)}まで</div>
                              期限を過ぎると注文は自動でキャンセルされます
                            </div>
                          </>
                        ):(
                          <>
                            <div className="title">
                              ロッカーお受け取り期限
                            </div>
                            <div className="content">
                              品質劣化防止の為にも、早めにお受け取りをお願いします。
                            </div>
                          </>
                        )}
                        <div className="title">
                          ロッカー開錠コード
                        </div>
                        <div className="content">
                          <div className="h5 text-danger">{activeOrder.lpspot?.locker_type === 'Arena' ? String(activeOrder.id).padStart(5, '0').slice(-5) : activeOrder.uber_order_id}</div>
                          ロッカーのタッチパネルに入力してください
                        </div>
                        <div className="title">
                          ロッカーのタッチパネルの操作方法
                        </div>
                        <div className="content">
                          {(Number(activeOrder.otype) === 1
                            ? ['「お客様」ボタンをタッチ', 'ロッカー開錠コードを入力', 'ロッカーが開錠', 'ロッカーにお預け', 'このページ下の「お預け完了」ボタンを押す']
                            : ['「お客様」ボタンをタッチ', 'ロッカー開錠コードを入力', 'ロッカーが開錠', 'ロッカーから受取る', 'このページ下の「自分で受け取る」ボタンを押す']
                          ).map((step, i, arr) => {
                            const isLast = i === arr.length - 1;
                            return (
                              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 0', borderTop: i > 0 ? '1px solid var(--border)' : 'none' }}>
                                <span style={{ flex: '0 0 auto', width: '28px', height: '28px', borderRadius: '50%', background: 'var(--brand)', color: 'var(--on-brand)', fontWeight: 700, fontSize: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{i + 1}</span>
                                <span style={{ fontWeight: isLast ? 700 : 500, color: 'var(--ink)' }}>{step}{isLast ? ' ⬇' : ''}</span>
                              </div>
                            );
                          })}
                        </div>
                        <div className="title">
                          ロッカーの位置
                        </div>
                        <div className="content">
                        {/* 地図だけでは分かりにくいという声（2026-08-20アンケート）を受け、住所を併記 */}
                        {activeOrder?.lpspot?.pref && (
                          <div className="mb-2">
                            〒{activeOrder?.lpspot?.zip} {activeOrder?.lpspot?.pref}{activeOrder?.lpspot?.add1}{activeOrder?.lpspot?.add2}{activeOrder?.lpspot?.add3}
                          </div>
                        )}
                        {/* ワンタップで現在地からの徒歩ナビを起動（Googleマップの経路URL。アプリがあればアプリで開く） */}
                        {activeOrder?.lpspot?.lat && (
                          <a
                            href={`https://www.google.com/maps/dir/?api=1&destination=${activeOrder?.lpspot?.lat},${activeOrder?.lpspot?.lon}&travelmode=walking`}
                            target="_blank" rel="noreferrer"
                            className="btn btn-sm btn-oval btn-black w-100 mb-2"
                            style={{ color: '#fff', textDecoration: 'none' }}
                          >
                            🧭 ロッカーまでナビを開始（Googleマップ）
                          </a>
                        )}
                        {activeOrder?.lpspot?.lat && activeOrder?.lpspot?.lon ? (
                          <>
                            <div className="">
                                <div className="w-100 confirmMap">
                                  <Map
                                    center={{ lat: Number(activeOrder?.lpspot?.lat), lng: Number(activeOrder?.lpspot?.lon) }}
                                    zoom={15}
                                    options={options}
                                  >
                                    <GMarker position={{ lat: Number(activeOrder?.lpspot?.lat), lng: Number(activeOrder?.lpspot?.lon) }} />
                                  </Map>
                                </div>
                            </div>
                          </>
                        ) : (
                          <div>ロッカー情報を読み込み中...</div>
                        )}
                        </div>
                        <div className="title">
                          ロッカー名
                        </div>
                        <div className="content">
                        {activeOrder?.lpspot?.name && (
                          <>
                            {activeOrder?.lpspot?.name} ランドリーパックNow専用ロッカー
                          </>
                        )}
                        </div>
                        <div className="title">
                          ロッカーの外見
                        </div>
                        <div className="content">
                        {activeOrder?.lpspot?.locker_image ? (
                          <>
                            <div className="">
                            < img src={activeOrder?.lpspot?.locker_image} className="ItemImage" alt="Item" />
                            </div>
                          </>
                        ) : (
                          <div>ロッカー情報を読み込み中...</div>
                        )}
                        </div>
                        <div className="title">
                          ロッカーに関するよくある質問
                        </div>
                        <div className="content">
                          <div className="mb-0" style={{ borderBottom: '1px solid #e0e0e0' }}>
                            <div
                              className="h6 mb-1 div_btn faq-question-row"
                              onClick={() => setOpenFaqIndex(openFaqIndex === 0 ? null : 0)}
                            >
                              <span className="faq-question-text">Q1.ロッカーが開きません</span>
                              <span className="faq-question-icon">
                                {openFaqIndex === 0 ? <IoChevronUp size={20} /> : <IoChevronDown size={20} />}
                              </span>
                            </div>
                            {openFaqIndex === 0 && (
                              <div className="mb-4" style={{
                                animation: 'slideDown 0.3s ease-out',
                                padding: '8px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '4px',
                                marginTop: '4px'
                              }}>
                                A1.ご迷惑をおかけして申し訳ございません。恐れ入りますが、注文履歴＞注文詳細を開き「コメント」欄にてお知らせください。2営業日以内にご返信いたします。
                              </div>
                            )}
                          </div>
                          <div className="mb-0" style={{ borderBottom: '1px solid #e0e0e0' }}>
                            <div
                              className="h6 mb-1 div_btn faq-question-row"
                              onClick={() => setOpenFaqIndex(openFaqIndex === 1 ? null : 1)}
                            >
                              <span className="faq-question-text">Q2.期限内に預けれませんでした</span>
                              <span className="faq-question-icon">
                                {openFaqIndex === 1 ? <IoChevronUp size={20} /> : <IoChevronDown size={20} />}
                              </span>
                            </div>
                            {openFaqIndex === 1 && (
                              <div className="mb-4" style={{
                                animation: 'slideDown 0.3s ease-out',
                                padding: '8px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '4px',
                                marginTop: '4px'
                              }}>
                                A2.お預け期限を過ぎると注文が自動でキャンセルされます。恐れ入りますが、再度ご注文をお願いいたします。
                              </div>
                            )}
                          </div>
                          <div className="mb-0" style={{ borderBottom: '1px solid #e0e0e0' }}>
                            <div
                              className="h6 mb-1 div_btn faq-question-row"
                              onClick={() => setOpenFaqIndex(openFaqIndex === 2 ? null : 2)}
                            >
                              <span className="faq-question-text">Q3.お預け完了ボタンを押し忘れました</span>
                              <span className="faq-question-icon">
                                {openFaqIndex === 2 ? <IoChevronUp size={20} /> : <IoChevronDown size={20} />}
                              </span>
                            </div>
                            {openFaqIndex === 2 && (
                              <div className="mb-4" style={{
                                animation: 'slideDown 0.3s ease-out',
                                padding: '8px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '4px',
                                marginTop: '4px'
                              }}>
                                A3.恐れ入りますが、注文履歴＞注文詳細を開き「コメント」欄にてお知らせください。2営業日以内にご返信いたします。
                              </div>
                            )}
                          </div>
                          <div className="mb-0" style={{ borderBottom: '1px solid #e0e0e0' }}>
                            <div
                              className="h6 mb-1 div_btn faq-question-row"
                              onClick={() => setOpenFaqIndex(openFaqIndex === 4 ? null : 4)}
                            >
                              <span className="faq-question-text">Q4.ロッカーの場所がわかりません</span>
                              <span className="faq-question-icon">
                                {openFaqIndex === 4 ? <IoChevronUp size={20} /> : <IoChevronDown size={20} />}
                              </span>
                            </div>
                            {openFaqIndex === 4 && (
                              <div className="mb-4" style={{
                                animation: 'slideDown 0.3s ease-out',
                                padding: '8px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '4px',
                                marginTop: '4px'
                              }}>
                                A4.ホームの「ロッカーの位置」の地図をご確認ください。それでもご不明な場合は、「注文履歴」＞「注文詳細」を開き「コメント」欄にてお知らせください。
                              </div>
                            )}
                          </div>
                          <div className="mb-0" style={{ borderBottom: '1px solid #e0e0e0' }}>
                            <div
                              className="h6 mb-1 div_btn faq-question-row"
                              onClick={() => setOpenFaqIndex(openFaqIndex === 6 ? null : 6)}
                            >
                              <span className="faq-question-text">Q5.預けた荷物を取り出したいです</span>
                              <span className="faq-question-icon">
                                {openFaqIndex === 6 ? <IoChevronUp size={20} /> : <IoChevronDown size={20} />}
                              </span>
                            </div>
                            {openFaqIndex === 6 && (
                              <div className="mb-4" style={{
                                animation: 'slideDown 0.3s ease-out',
                                padding: '8px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '4px',
                                marginTop: '4px'
                              }}>
                                A5.ロッカーに預け入れ後のキャンセル・返却は原則お受けしておりません。やむを得ない事情がある場合は、注文履歴＞注文詳細の「コメント」欄よりご相談ください。
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}

                {orderSelfAtStore(activeOrder) && (
                  <>
                    {((activeOrder.user_dropoff_type==='own' && Number(activeOrder.otype)===1) ||  Number(activeOrder.otype)===6) && (
                      <>
                        <h4 ref={lockerRef} className="ml-1 mb-1">店舗について</h4>
                        {Number(activeOrder.otype)===1 ? (
                          <>
                            <div className="title">
                              店舗お預け期限
                            </div>
                            <div className="content">
                              ご注文から<span className="h5 text-danger">{activeOrder?.lpspot?.spot_dropoff_limit_days}日以内</span>
                              {calculateDropoffDeadline(activeOrder.order_day, activeOrder?.lpspot?.spot_dropoff_limit_days) && (
                                <span className="h5 text-danger">({calculateDropoffDeadline(activeOrder.order_day, activeOrder?.lpspot?.spot_dropoff_limit_days)}まで)</span>
                              )}
                              に店舗にお預けください
                            </div>
                          </>
                        ):(
                          <>
                            <div className="title">
                              店舗お受け取り期限
                            </div>
                            <div className="content">
                              品質劣化防止の為にも、早めにお受け取りをお願いします。
                            </div>
                          </>
                        )}
                        <div className="title">
                          店舗営業時間
                        </div>
                        <div className="content">
                        {activeOrder?.lpspot?.holiday && (
                          <div>
                            {activeOrder.lpspot.holiday}
                          </div>
                        )}
                        {activeOrder?.lpspot?.business_hours && (
                          <div>
                            {activeOrder?.lpspot?.business_hours}
                          </div>
                        )}
                        </div>
                        <div className="title">
                          店舗の位置
                        </div>
                        <div className="content">
                        {activeOrder?.lpspot?.lat && activeOrder?.lpspot?.lon ? (
                          <>
                            <div className="">
                                <div className="w-100 confirmMap">
                                  <Map
                                    center={{ lat: Number(activeOrder?.lpspot?.lat), lng: Number(activeOrder?.lpspot?.lon) }}
                                    zoom={15}
                                    options={options}
                                  >
                                    <GMarker position={{ lat: Number(activeOrder?.lpspot?.lat), lng: Number(activeOrder?.lpspot?.lon) }} />
                                  </Map>
                                </div>
                            </div>
                          </>
                        ) : (
                          <div>店舗情報を読み込み中...</div>
                        )}
                        </div>
                        <div className="title">
                          店舗名
                        </div>
                        <div className="content">
                        {activeOrder?.lpspot?.name && (
                          <>
                            {activeOrder?.lpspot?.name}
                          </>
                        )}
                        </div>
                        <div className="title">
                          店舗の外見
                        </div>
                        <div className="content">
                        {activeOrder?.lpspot?.spot_image ? (
                          <>
                            <div className="">
                            < img src={activeOrder?.lpspot?.spot_image} className="ItemImage" alt="Item" />
                            </div>
                          </>
                        ) : (
                          <div>店舗情報を読み込み中...</div>
                        )}
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
            )}

            {Number(activeOrder.otype) === 1 ? (
              <>
              {bagStage !== '' ? null : activeOrder.user_dropoff_type==='uber' ? (
                <>
                  {Number(activeOrder.delivery_type)===-1 ?(
                    <div className="flex_div">
                      <div className="mb-3">
                        <button className="btn btn-oval btn-outline-secondary form-control" onClick={openTrackingUrl}>配送状況の確認</button>
                      </div>
                    </div>
                  ):activeOrder.delivery_type === null && (
                    <>
                      {activeOrder.item_type === 'bag' || activeOrder.item_type === 'futon_bag' ? (
                        <div className="">
                          <div className="flex_div">
                            <div className="mb-2">
                              <button className="btn btn-oval btn-yellow form-control" onClick={openDeliveryBagModal}>配達を依頼する</button>
                            </div>
                            <div className="text-center">
                              <small style={{ whiteSpace: 'pre-line' }}>受付時間：{activeOrder.business_hours_txt}</small>
                            </div>
                          </div>
                          <div className="mb-6">
                          </div>
                        </div>
                      ) : (
                        <div className="">
                          <div className="flex_div">
                            <div className="mb-2">
                              <button className="btn btn-oval btn-yellow form-control" onClick={openDeliveryCustomerPickupModal}>配達を依頼する</button>
                            </div>
                            <div className="text-center">
                              <small style={{ whiteSpace: 'pre-line' }}>受付時間：{activeOrder.business_hours_txt}</small>
                            </div>
                          </div>
                          <div className="mb-6">
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </>
              ):activeOrder.user_dropoff_type==='own' && !orderSelfAtStore(activeOrder) && (
                <>
                  <div className="flex_div">
                    <div className="mb-3">
                      <button className="btn btn-oval btn-outline-secondary form-control" onClick={openDropoffModal}>お預け完了</button>
                    </div>
                  </div>
                </>
              )}
              </>
            ) : Number(activeOrder.otype) === 6 ? (
              <div className="flex_div">
              <div className="text-center mb-2">
                <small style={{ whiteSpace: 'pre-line' }}>受付時間：{activeOrder.business_hours_txt}</small>
              </div>
                <div className="">
                  {Number(activeOrder?.lpspot?.can_user_dropoff_locker) === 1 ? (
                    <div className="row">
                      <div className="col-6">
                          <button className="btn btn-half btn-oval btn-uber form-control" onClick={openDeliveryModal}>自宅へ配達（Uber）</button>
                      </div>
                      <div className="col-6">
                          <button className="btn btn-half btn-oval btn-own form-control" onClick={orderSelfAtStore(activeOrder) ? openSpotPickupModal : openLockerPickupModal}>{orderSelfAtStore(activeOrder) ? '店舗で受け取る' : 'ロッカーで受け取る'}</button>
                      </div>
                    </div>
                  ) : (
                    <div className="mb-3">
                      <button className="btn btn-oval btn-uber form-control" onClick={openDeliveryModal}>自宅へ配達（Uber）</button>
                    </div>
                  )}
                </div>
              </div>
            ) : Number(activeOrder.otype) === 7 && (
              <div className="flex_div">
                <div className="">
                  <button className="btn btn-oval btn-outline-secondary form-control" onClick={openTrackingUrl}>配送状況の確認</button>
                </div>
              </div>
            )}
          </div>
        </div>

        <Modal>
          <div className="modal rounded  pb-4 pl-4 pr-4">
            <div className="">
              <img src="/img/step2-00.png" alt="modal_image" className="ItemImage" />
            </div>
            <div className="">
              <div className="mb-3">
                <div className=" mb-3">
                  <div className="h6">
                    専用バッグをにご自宅にお届けします<br/>
                    以下の暗証番号を<br/>
                    Uber配達員にお伝えください
                  </div>
                </div>
                <div className=" mb-3 text-center">
                  <div className="h2">
                    {activeOrder !== null && (
                      <div>
                        {activeOrder.pincode}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="mb-3">
                <div className="text-danger">
                  ※ご依頼品を専用バッグに入れて、しっかりと密封してください。
                </div>
                <div className="text-danger">
                  ※しっかりと密封されていない場合、サービスをお受けできない場合があります。
                </div>
              </div>
              <div className="mb-2">
                <button onClick={closeModal} className="btn btn-oval btn-outline-secondary form-control">確認しました</button>
              </div>
            </div>
          </div>
        </Modal>

        <LoadingModal>
          <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
            <button onClick={closeLoadingModal} className="hide">閉じる</button>
            <div >
              <TailSpin stroke="#000" />
            </div>
            <div className="">
              <div className="">
                処理中です
              </div>
            </div>
          </div>
        </LoadingModal>

        <DeliveryBagModal>
          <div className="modal rounded p-4">
            <div className="">

              <div className="row">
                <div className="col-12 text-right">
                  <IoClose onClick={closeDeliveryBagModal} className="h2 text-gray-dark" />
                </div>
              </div>
              <div className="">
                <div className="h5 text-center mb-2">
                  今からUber配達員がご自宅へ向かいます<br />
                  本当に配達を依頼してよろしいですか？
                </div>
              </div>
              <div>
                <div className="row mb-4">
                  <div className="col-12">
                    <img src="/img/delivery.png" alt="DeliveryImage" className="ItemImage" />
                  </div>
                </div>
                <div className="mb-4">
                  30〜60分前後で到着予定です。
                  <div className="text-danger h6">※この操作は取り消せません！</div>
                  <div className="text-danger h6">※戻るには右上の×ボタンを押してください</div>
                </div>
                <div className="">
                  <button className="btn btn-oval btn-outline-secondary form-control" onClick={requestDeliveryBag}>配達を依頼する</button>
                </div>
              </div>
            </div>
          </div>
        </DeliveryBagModal>

        <DeliveryCustomerPickupModal>
          <div className="modal rounded p-4">
            <div className="">
              <div className="row">
                <div className="col-12 text-right">
                  <IoClose onClick={closeDeliveryCustomerPickupModal} className="h2 text-gray-dark" />
                </div>
              </div>
              <div className="">
                <div className="h5 text-center mb-2">
                  今からUber配達員がご自宅へ向かいます<br />
                  本当に配達を依頼してよろしいですか？
                </div>
              </div>
              <div>
                <div className="row mb-4">
                  <div className="col-12">
                    <img src="/img/delivery.png" alt="DeliveryImage" className="ItemImage" />
                  </div>
                </div>
                <div className="mb-4">
                  10〜60分前後で到着予定です。
                  <div className="text-danger h6">※この操作は取り消せません！</div>
                  <div className="text-danger h6">※戻るには右上の×ボタンを押してください</div>
                </div>
                <div className="">
                  <button className="btn btn-oval btn-outline-secondary form-control" onClick={requestDeliveryCustomerPickup}>配達を依頼する</button>
                </div>
              </div>
            </div>
          </div>
        </DeliveryCustomerPickupModal>

        <DeliveryModal>
          <div className="modal rounded p-4">
            <div className="">

              <div className="row">
                <div className="col-12 text-right">
                    <IoClose onClick={closeDeliveryModal} className="h2 text-gray-dark"/>
                </div>
              </div>
              <div className="">
                <div className="h5 text-center mb-2">
                  今からUber配達員がご自宅へ<br />
                  お届けに向かいます<br />
                  本当によろしいですか？
                </div>
              </div>
              <div>
                <div className="row mb-4">
                  <div className="col-12">
                    <img src="/img/delivery.png" alt="DeliveryImage" className="ItemImage" />
                  </div>
                </div>
                <div className="mb-4">
                  配達依頼後30〜60分前後で到着予定です。Uber配達員が到着したらご依頼品をお受け取りください。
                  <div className="text-danger h6">※この操作は取り消せません！</div>
                  <div className="text-danger h6">※戻るには右上の×ボタンを押してください</div>
                </div>
                <div className="">
                  <button className="btn btn-oval btn-uber form-control" onClick={requestDelivery}>Uberが今すぐ届ける</button>
                </div>
              </div>
            </div>
          </div>
        </DeliveryModal>

        <DropoffModal>
          <div className="modal rounded p-4">
            <div className="">

              <div className="row">
                <div className="col-12 text-right">
                    <IoClose onClick={closeDropoffModal} className="h2 text-gray-dark"/>
                </div>
              </div>
              <div className="">
                <div className="h5 text-center mb-2">
                  ロッカーへのお預けが<br/>完了しましたか？
                </div>
              </div>
              <div>
                <div className="row mb-4">
                  <div className="col-12">
                    <img src="/img/locker.png" alt="DeliveryImage" className="ItemImage" />
                  </div>
                </div>
                <div className="mb-4">
                  ロッカーへのお預けが完了したら、下のボタンを押してください
                  <div className="text-danger h6">※この操作は取り消せません！</div>
                  <div className="text-danger h6">※ロッカーを開錠できなくなります！</div>
                  <div className="text-danger h6">※戻るには右上の×ボタンを押してください</div>
                </div>
                <div className="">
                  <button className="btn btn-oval btn-own form-control" onClick={successDropoff}>お預け完了</button>
                </div>
              </div>
            </div>
          </div>
        </DropoffModal>

        <LockerPickupModal>
          <div className="modal rounded p-4">
            <div className="">

              <div className="row">
                <div className="col-12 text-right">
                    <IoClose onClick={closeLockerPickupModal} className="h2 text-gray-dark"/>
                </div>
              </div>
              <div className="">
                <div className="h5 text-center mb-2">
                  ロッカーでのお受け取り方法
                </div>
              </div>
              <div>
                <div className="title">
                  ロッカー開錠コード
                </div>
                <div className="content">
                  <div className="h4 text-danger">{activeOrder.lpspot?.locker_type === 'Arena' ? String(activeOrder.id).padStart(5, '0').slice(-5) : activeOrder.uber_order_id}</div>
                  ロッカーのタッチパネルに入力してください
                </div>
                <div className="title">
                  お受け取りの手順
                </div>
                <div className="content">
                  {[
                    'ロッカーのタッチパネルで「お客様」をタッチ',
                    '開錠コードを入力',
                    'ロッカーが開錠 → お品物を受け取る',
                    '下の「お受け取り完了」ボタンを押す',
                  ].map((step, i, arr) => {
                    const isLast = i === arr.length - 1;
                    return (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 0', borderTop: i > 0 ? '1px solid var(--border)' : 'none' }}>
                        <span style={{ flex: '0 0 auto', width: '28px', height: '28px', borderRadius: '50%', background: 'var(--brand)', color: 'var(--on-brand)', fontWeight: 700, fontSize: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{i + 1}</span>
                        <span style={{ fontWeight: isLast ? 700 : 500, color: 'var(--ink)' }}>{step}{isLast ? ' ⬇' : ''}</span>
                      </div>
                    );
                  })}
                </div>
                <div className="mb-4">
                  <div className="text-danger h6">※お品物を取り出してから「お受け取り完了」を押してください</div>
                  <div className="text-danger h6">※完了を押すと取り消せません（ロッカーを再度開けられなくなります）</div>
                  <div className="text-danger h6">※まだの場合は右上の×ボタンで戻れます</div>
                </div>
                <div className="">
                  <button className="btn btn-oval btn-own form-control" onClick={successPickup}>お受け取り完了</button>
                </div>
              </div>
            </div>
          </div>
        </LockerPickupModal>

        <SpotPickupModal>
          <div className="modal rounded p-4">
            <div className="">

              <div className="row">
                <div className="col-12 text-right">
                    <IoClose onClick={closeSpotPickupModal} className="h2 text-gray-dark"/>
                </div>
              </div>
              <div className="">
                <div className="h5 text-center mb-2">
                  店舗で受け取る
                </div>
              </div>
              <div>
                <div className="row mb-4">
                  <div className="col-12">
                    <img src="/img/futon-dropoff.png" alt="DeliveryImage" className="ItemImage" />
                  </div>
                </div>
                <div className="mb-2">
                  店舗で受け取ることができます。<br/>
                  営業時間内にお越しください。
                </div>
                <div className="mb-2">
                  <div className="h6">
                    {activeOrder?.lpspot?.business_hours}
                  </div>
                  <div className="h6">
                    {activeOrder?.lpspot?.holiday}
                  </div>
                </div>
                <div className=" text-danger h6">
                  ※ロッカーではありません。
                </div>
                <div className="mb-4 text-danger h6">
                  ※店舗で受け取ると300円クーポンプレゼント!
                </div>
                <div className="">
                  <button className="btn btn-oval btn-own form-control" onClick={closeSpotPickupModal}>OK</button>
                </div>
              </div>
            </div>
          </div>
        </SpotPickupModal>
        <Tabbar menu="home" />
      </div>
    </div>
  );
}

export default OrderDetail;
